import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import vipIcon from 'assets/svg/vip-icon.svg';
import { H5 } from 'components/typography/Headers';
import { CurrentUserDto } from 'services/user/userService.dto';
import { extractUserName } from 'utils/extractUserName';

const Name = styled(H5)`
  font-weight: bold;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 9px;
  margin-bottom: 48px;

  ${theme.mq.tablet} {
    margin-bottom: 24px;
  }
`;

const VipIcon = styled.img`
  width: 30px;
  height: 30px;
`;

interface UserNameProps {
  currentUser: CurrentUserDto;
}

export const UserName = ({ currentUser }: UserNameProps) => {
  return (
    <Container>
      <Name data-testid={'user-name'}>{extractUserName(currentUser)}</Name>
      {currentUser.vip && <VipIcon data-testid={'vip-icon'} src={vipIcon} />}
    </Container>
  );
};
